/**
 * Shared inline style objects for the Event tab (list, form, fields) so layout stays consistent without a CSS module.
 * Centralized here to avoid repeating the same literals across `EventForm`, `EventList`, and small field components.
 */

/** Primary actions: submit, list actions, add point. */
export const buttonStyle = {
    backgroundColor: '#002b37',
    fontFamily: 'Gilory-Bold',
    border: 'solid 1px #d7d7d7',
    padding: '8px 12px',
    borderRadius: '10px',
    cursor: 'pointer',
    color: '#ffffff'
};

/** Secondary/neutral actions: reset, remove row, cancel-style affordances. */
export const cancelStyle = {
    backgroundColor: '#d7d7d7',
    fontFamily: 'Gilory-Bold',
    border: 'solid 1px #d7d7d7',
    padding: '8px 12px',
    borderRadius: '10px',
    cursor: 'pointer',
    color: '#ffffff'
};

/** Table header cells for the event list. */
export const thStyle = {
    padding: '12px',
    border: '1px solid #ddd',
    textAlign: 'left'
};

/** Table body cells for the event list. */
export const tdStyle = {
    padding: '12px',
    border: '1px solid #ddd'
};

/** Full-width text/select inputs in the main form grid. */
export const inputStyle = {
    width: '100%',
    padding: '8px',
    marginBottom: '20px',
    border: '1px solid #ccc',
    borderRadius: '4px'
};

/** Fixed-size preview for uploaded event images. */
export const imgStyle = {
    width: '250px',
    height: '250px',
    objectFit: 'cover',
    marginBottom: '20px'
};

/** Bold block labels above full-width fields. */
export const labelStyle = {
    display: 'block',
    marginBottom: '10px',
    fontWeight: 'bold'
};

/** Smaller labels used inside grouped controls (e.g. time range). */
export const labelStyle1 = {
    display: 'block',
    marginBottom: '5px'
};

/** Compact inputs nested inside flex rows (time cells, point draft row). */
export const inputStyle1 = {
    width: '100%',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px'
};

/** List row layout for removable bullet points. */
export const liStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    marginBottom: '8px'
};

/** Wrapper for the create/edit form column (width + padding). */
export const formContainerStyle = {
    fontFamily: 'Arial, sans-serif',
    padding: '20px',
    width: '50%'
};

/** Offset main content beside the fixed left navigation on the Event tab page. */
export const pageContentStyle = {
    marginLeft: '220px',
    width: '100%',
    overflow: 'auto'
};

/** Horizontal layout for “from / to” time inputs. */
export const timeRowStyle = {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px'
};

/** Equal flex columns within the time row. */
export const timeCellStyle = {
    flex: 1
};

/** Unstyled list for point rows (spacing handled on `li`). */
export const plainListStyle = {
    listStyleType: 'none',
    padding: 0
};

/** Groups draft input + add button for point list fields. */
export const fieldActionStyle = {
    marginBottom: '20px'
};

/** Character count shown below length-limited text fields. */
export const charCountStyle = {
    display: 'block',
    marginTop: '-12px',
    marginBottom: '20px',
    fontSize: '12px',
    color: '#666',
    textAlign: 'right'
};
